import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Flattrade: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>Flattrade API Setup in 7 Steps</h3>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            To start<span>click on this link</span> to Access the Flattrade API Portal
          </h2>
          <button className="stepper-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 3H21V9"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 14L21 3"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <a href="https://wall.flattrade.in/login" target="blank" rel="noreferrer">
              Open Dashboard{' '}
            </a>
          </button>
        </div>
      </li>
      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click <span>Pi </span>on the top right corner{' '}
          </h2>
          <img
            src="/landing-page-img/brokers-img/flattrade-1.png"
            className="w-100"
            alt="Flattrade XTS login"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click on <span>Create new API Key</span>
          </h2>
          <img
            src="/landing-page-img/brokers-img/flattrade-2.png"
            className="w-100"
            alt="Flattrade new API Key"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <h2 className="stepper__heading">Fill below details and submit.</h2>

          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6 className="mb-0">App Name</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Quantman" disabled />
                </span>
                <CopyTextButton text="QuantMan" />
              </div>
            </div>

            <div className="stepper__form-group">
              <h6 className="mb-0">App ShortName</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Quantman" disabled />
                </span>
                <CopyTextButton text="QuantMan" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6 className="mb-0">Redirect URL</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="https://quantman.trade/auth/flattrade/callback" disabled />
                </span>
                <CopyTextButton text="https://quantman.trade/auth/flattrade/callback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6 className="mb-0">Postback URL</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="https://www.quantman.trade/flattrade/postback" disabled />
                </span>
                <CopyTextButton text="https://www.quantman.trade/flattrade/postback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6 className="mb-0">Description</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Quantman" disabled />
                </span>
                <CopyTextButton text="QuantMan" />
              </div>
            </div>
          </div>
          <img src="/landing-page-img/brokers-img/flattrade-3.png" alt="Flattrade fill form" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Press <span>Eye icon</span> to show secret key
          </h2>
          <img src="/landing-page-img/brokers-img/flattrade-4.png" alt="Flattrade secret key" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Now, you can Copy and paste api details in appropriate fields below.
          </h2>
          <img
            src="/landing-page-img/brokers-img/flattrade-5.png"
            className="w-100"
            alt="Flattrade API details"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click the back button and fill the API credentials in the required field
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="Flattrade fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default Flattrade;
